import { useMutation } from "@tanstack/react-query";
import { toast } from "sonner";

import { getOutputTemplateDetail } from "@/api";

export function useOpenOutputTemplateOriginal(templateId: number) {
    const originalFile = useMutation({
        mutationFn: () => getOutputTemplateDetail(templateId),
    });

    const openOriginal = () => {
        const win = window.open("", "_blank");
        if (!win) {
            toast.error("Couldn't open the file. Allow pop-ups and try again.");
            return;
        }
        win.opener = null;
        void originalFile.mutateAsync().then(
            (result) => {
                if (result.original_download_url) {
                    win.location.href = result.original_download_url;
                    return;
                }
                win.close();
                toast.warning("File link is not available yet");
            },
            () => {
                win.close();
                toast.error("Couldn't fetch the file link");
            }
        );
    };

    return {
        openOriginal,
        isPending: originalFile.isPending,
    };
}
